/**
 * Finds the enum wrapper object that matches the given enum value within the provided array.
 *
 * @param value an enum
 * @param allDtos the array of enum wrapper objects
 */
export const findEnumObject = <TEnum, TEnumDto extends { value: TEnum, text: string }>(
  value: TEnum, allDtos: TEnumDto[]) => allDtos.find((dto) => dto.value === value);

export const findEnumLabel = <TEnum, TEnumDto extends { value: TEnum, text: string }>(
  value: TEnum, allDtos: TEnumDto[]) => findEnumObject(value, allDtos)?.text;

export const getGroundTransportType = (value: server.dto.GroundTransportTypes, serverReference: server.dto.ServerReference): server.dto.GroundTransportType => findEnumObject(value, serverReference.groundTransportTypes)!;

export const getPickupLocationType = (value: server.dto.PickupLocationTypes, serverReference: server.dto.ServerReference): server.dto.PickupLocationType => findEnumObject(value, serverReference.pickupLocationTypes)!;

export const getAppointmentPhase = (value: server.dto.AppointmentPhases, serverReference: server.dto.ServerReference): server.dto.AppointmentPhase => findEnumObject(value, serverReference.appointmentPhases)!;

export const getTrainTravelClass = (value: server.dto.TrainTravelClasses, serverReference: server.dto.ServerReference): server.dto.TrainTravelClass => findEnumObject(value, serverReference.trainTravelClasses)!;
